module.exports = __webpack_public_path__ + "static/media/Developer.ef5400fa.png";